import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import recentQuery from '../hooks/QueryRecentMateriais'
import spotlightQuery from '../hooks/QueryMateriaisSpotlight'
import decodeEntities from '../util/textDecode'

import { device } from './Breakpoints'
import { colors } from './Colors'

import imgCurso from '../img/alto-risco.png'

const Container = styled.section`
  width: 100%;
  .center {
    max-width: 1114px;
    margin: auto;
    display: flex;
    justify-content: flex-start;
    @media ${device.mobileL} {
      max-width: 100%;
      text-align: center;
      flex-wrap: wrap;
    }
    h2 {
      color: ${colors.verde};
      font-size: 1.2em;
      @media ${device.mobileL} {
        margin-top: 1em;
      }
    }
  }
  .recentPosts {
    width: 33.33%;
    @media ${device.mobileL} {
      width: 100%;
    }
    .thumb {
      max-height: 200px;
      overflow: hidden;
      margin: 0 0 2px 2px;
      :nth-child(3) {
        .content {
          background-color: rgba(164, 165, 211, 0.8);
          :hover {
            background-color: rgba(0, 0, 0, 0.6);
          }
        }
      }
      :nth-child(2) {
        .content {
          background-color: rgba(237, 181, 130, 0.8);
          :hover {
            background-color: rgba(0, 0, 0, 0.6);
          }
        }
      }
      .content {
        padding: 2em;
        @media ${device.mobileL} {
          height: 215px;
        }
      }
      .title {
        width: 90%;
      }
      .excerpt {
        width: 90%;
      }
      .tipo {
        border: 1px solid #ffffff;
        background: none;
      }
    }
  }
  .spotlight {
    width: 66.66%;
    @media ${device.mobileL} {
      width: 100%;
    }
    a {
      @media ${device.mobileL} {
        text-align: left;
      }
      .content {
        padding: 2em;
        background-color: rgba(20, 20, 20, 0.5);
        @media ${device.mobileL} {
          height: 215px;
        }
      }
      .title {
        width: 70%;
        @media ${device.mobileL} {
          width: 100%;
        }
      }
      .excerpt {
        width: 70%;
        @media ${device.mobileL} {
          width: 100%;
        }
      }
    }
    .tipo {
      border: 0;
    }
  }
  .spotlight,
  .recentPosts {
    box-sizing: border-box;
    a {
      display: block;
      background-repeat: no-repeat;
      background-size: cover;
      color: #ffffff;
      text-decoration: none;
      @media ${device.mobileL} {
        text-align: left;
      }
      .content {
        min-height: 322px;
        display: block;
        @media ${device.mobileL} {
          min-height: 100%;
        }
        .title {
          display: block;
          font-size: 1.1em;
          margin: 1em 0;
        }
        .excerpt {
          display: block;
          font-size: 0.7em;
        }
        .tipo {
          margin: 0 0.5em 0 0;
          padding: 0.5em 0.8em;
          border-radius: 5px;
          width: auto;
          color: #ffffff;
          font-size: 0.6em;
          background: ${colors.lilas};
        }
        :hover {
          background-color: rgba(0, 0, 0, 0.6);
        }
      }
    }
  }
`

const MateriaisSpotlight = () => {
  const spotlight = spotlightQuery()
  const materiais = recentQuery()

  return (
    <Container>
      <div className="center">
        <div className="spotlight">
          <h2>Destaque</h2>
          {spotlight.map(material => (
            <a
              href={material.materiaisEducativos.link}
              target="_blank"
              rel="noreferrer"
              key={material.id}
              style={{
                backgroundImage: `url( ${
                  material.materiaisEducativos.imagemDestaque !== null
                    ? material.materiaisEducativos.imagemDestaque.sourceUrl
                    : imgCurso
                })`,
              }}
            >
              <span className="content">
                <span
                  className={
                    material.materiaisEducativos.tipo === 'Ebook'
                      ? 'ebook tipo'
                      : 'tipo'
                  }
                >
                  {material.materiaisEducativos.tipo}
                </span>
                <span className="title">{decodeEntities(material.title)}</span>
                <span
                  className="excerpt"
                  dangerouslySetInnerHTML={{
                    __html: material.excerpt.replace(
                      /<p class="link-more.*/,
                      ''
                    ),
                  }}
                />
              </span>
            </a>
          ))}
        </div>
        <div className="recentPosts">
          <h2>Mais recentes</h2>
          {materiais.map(material => (
            <a
              href={material.materiaisEducativos.link}
              target="_blank"
              rel="noreferrer"
              key={material.id}
              className="thumb"
              style={{
                backgroundImage: `url( ${
                  material.materiaisEducativos.imagemDestaque.sourceUrl !== null
                    ? material.materiaisEducativos.imagemDestaque.sourceUrl
                    : imgCurso
                })`,
              }}
            >
              <span className="content">
                <span className="title">{decodeEntities(material.title)}</span>
              </span>
              <ul className="tipo">
                <li>{material.materiaisEducativos.tipo}</li>
              </ul>
            </a>
          ))}
        </div>
      </div>
    </Container>
  )
}

MateriaisSpotlight.propTypes = {
  materiais: PropTypes.arrayOf(PropTypes.object),
}
export default MateriaisSpotlight
